import { GameAssets, Module } from "@ak/game-assets"

const Client = GameAssets.create({ locale: "jp" })

export const getItem = (id: string) => Client.get(Module.ITEM, id)
